import { Routes } from '@angular/router';
import { getParentRoutes } from './routes/parent.routes';
import { getSchoolRoutes } from './routes/school.routes';
import { getFallBackRoutes } from './routes/fall-back.routes';
import { getAdminRoutes } from './routes/admin.routes';
import { getPatrolRoutes } from './routes/patrol.routes';
import { getOAuthRoutes } from './routes/oauth.routes';

export function resolveRoutes(): Routes {
  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0] ?? '';

  const routesMap: Record<string, Routes> = {
    family: getParentRoutes(),
    school: getSchoolRoutes(),
    admin: getAdminRoutes(),
    patrol: getPatrolRoutes(),
    oauth: getOAuthRoutes(),
    '': getFallBackRoutes(), // Default if no subdomain is present
  };

  return routesMap[subdomain] ?? getFallBackRoutes();
}
